import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

// importing pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import Work from "./pages/Work";
import Error from "./pages/Error";
import Projects from "./pages/Projects";

// Error or Success Notification
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const styles = {
  scrollToTop: "w-20 h-20 centerContent hover:-translate-y-1 transition ease-in-out duration-300"
}

function App() {
  return (
    <>
      <Router>
        <ScrollToTop smooth color="#FF4092" width={25} height={25} className={styles.scrollToTop} style={{borderRadius: '50%'}} />
        <Routes>
          <Route element={<Home />} path="/" />
          <Route element={<Services />} path="/services" />
          <Route element={<Work />} path="/work" />
          <Route element={<Projects />} path="/projects/:id" />
          <Route path="*" element={<Error />} />
        </Routes>
        {/* <Footer /> */}
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;